import { sliderConstants } from '../constants';

export function sliders(state = {}, action) {
  switch (action.type) {
    case sliderConstants.GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case sliderConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false
      }
    case sliderConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function AddSlider(state = {}, action) {
  switch (action.type) {
    case sliderConstants.ADD_REQUEST:
      return {
        state,
        loading: true,
      }
    case sliderConstants.ADD_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case sliderConstants.ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}

export function GetSlider(state = {}, action) {
  switch (action.type) {
    case sliderConstants.GET_REQUEST:
      return {
        state,
        loading: true,
      }
    case sliderConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case sliderConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function UpdateSlider(state = {}, action) {
  switch (action.type) {
    case sliderConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true,
      }
    case sliderConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case sliderConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}